import { render, staticRenderFns } from "./userWalletLog2.vue?vue&type=template&id=4fff5d26&scoped=true&"
import script from "./userWalletLog2.vue?vue&type=script&lang=js&"
export * from "./userWalletLog2.vue?vue&type=script&lang=js&"
import style0 from "./userWalletLog2.vue?vue&type=style&index=0&id=4fff5d26&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fff5d26",
  null
  
)

export default component.exports